import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import MainModal from '../../../../components/dashboard/modal/MainModal'

import useMutation from '../../../../hooks/useMutation'
import useFetch from '../../../../hooks/useFetch'

import {
  setModal,
  showApplicants,
} from '../../../../store/actions/listsActions'
import { updateTalents } from '../../../../store/actions/talentActions'
import { P } from '../../../../style/Typography.style'

const AddApplicantToList = () => {
  const dispatch = useDispatch()
  const { addToast } = useToasts()
  const { applicant, moveList, applicants } = useSelector(
    (state) => state.lists
  )

  const { talents } = useSelector((state) => state.talents)

  const { data, loading, success, error, handleRequest } = useMutation()

  const { data: channel } = useFetch('/channels')

  function handleAddList() {
    const defaultChannel = channel.data.data.filter(
      (x) => x.channel === 'Careers Dashboard'
    )[0].id

    const data = {
      job_id: moveList?.id ? moveList?.id.toString() : '',
      added_by: 'Recruiter',
      channel_id: defaultChannel,
    }

    handleRequest(
      `applicant/${applicant.applicantId}/add-to-screening`,
      data,
      'POST'
    )
  }

  useEffect(() => {
    if (data) {
      const filteredApplicants = talents.filter(
        (user) => user.id !== data.resp?.applicant?.id
      )

      const selectedApplicant = talents.find(
        (user) => user.id === data.resp?.applicant?.id
      )

      selectedApplicant.role = moveList?.title

      dispatch(showApplicants([...applicants, data.resp?.applicant]))
      dispatch(updateTalents([selectedApplicant, ...filteredApplicants]))
      dispatch(setModal(''))
      addToast(`Added ${applicant?.applicantName} to ${moveList?.title}`, {
        appearance: 'success',
        autoDismiss: true,
      })
    }
  }, [success])

  useEffect(() => {
    if (error) {
      addToast(
        error?.response?.data?.recruiterError ||
          error?.response?.message ||
          'Something went wrong',
        {
          appearance: 'error',
          autoDismiss: true,
        }
      )
    }
  }, [error])

  return (
    <MainModal
      title="Add Applicant to List"
      buttonText="Add"
      loading={loading}
      onClick={handleAddList}
    >
      <P>
        {applicant.applicantName} will be added to {moveList.title}?
      </P>
    </MainModal>
  )
}

export default AddApplicantToList
